// 图片视频上传
<template>
    <div class="group">
        <el-row>
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-edit"></i>
                        <span>上传图片/视频</span>
                    </div>
                    <!-- action="https://zjinsight.vip/seagullpj/params/uploadExcelFile" 
                        action="http://192.168.110.145:8080/ldspj/diamond/uploadImage"
                        action="https://mn.ldsgia.com/ldspj/diamond/uploadImage"
                    -->
                    <div class="search-content mar_b">
                        <el-upload class="upload-demo" 
                                name = "fileList"
                                ref="upload"
                                action="https://mn.ldsgia.com/ldspj/diamond/uploadImage"
                                :auto-upload="false"
                                :data="{user:user}"
                                :multiple="true"
                                :before-upload="beforeUpload"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :on-preview="handlePreview" 
                                :on-remove="handleRemove" >
                            <el-button type="primary" slot="trigger" size="big">选取图片/视频</el-button>
                            <el-button type="success" @click="submitUpload" size="big">上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="font-size:20px">只能上传jpg/png/mp4/mov格式的文件</div>
                        </el-upload>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    import axios from 'axios/index';
    import config_1 from '../../common/js/config.js';
    import cookieOperation from '../../common/js/cookieOperation';
    export default {
        data() {
            return {
                fileList: [],
                user:'admin',
                companyList: {
                    company_code: '',
                    company_name: '',
                }
                // userInfoAllList:[],
                // uploadForm : new FormData(),
            };
        },
        methods: {
            handleSuccess(res, file){
                if(res.flag){
                    this.successMsg('上传成功');
                }else{
                    this.errorMsg('上传失败');
                }
                console.log(res);
            },
            handleError(res, file){
                this.errorMsg('上传失败');
                console.log(res);
                if ("502" == res.code) {
                    this.$router.push('/login');
                }
            },
            handlePreview(file) {
                console.log(file);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            beforeUpload(file) {
                const extension = file.name.split(".")[1] === "jpg";
                const extension2 = file.name.split(".")[1] === "png";
                const extension3 = file.name.split(".")[1] === "JPG";
                const extension4 = file.name.split(".")[1] === "PNG";
                const extension5 = file.name.split(".")[1] === "MP4";
                const extension6 = file.name.split(".")[1] === "mp4";
                const extension7 = file.name.split(".")[1] === "MOV";
                const extension8 = file.name.split(".")[1] === "mov";
                if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 && !extension7 && !extension8) {
                    alert('上传附件只能是jpg/png/mp4/mov格式！');
                    return false;
                }
            },
            submitUpload() {
                this.$refs.upload.submit();
                this.fileList = [];
            },
            /*
            download() {
                let company_type = this.companyList.company_type;
                // 五类分类进行 文件下载
                if ('C' === company_type || '中介类' === company_type) {
                    window.location.href = '/download/cmodel.zip';
                } else if ('D' === company_type || '研发类' === company_type) {
                    window.location.href = '/download/dmodel.zip';
                } else if ('F' === company_type || '资金类' === company_type) {
                    window.location.href = '/download/fmodel.zip';
                } else if ('M' === company_type || '制造类' === company_type) {
                    window.location.href = '/download/mmodel.zip';
                } else if ('S' === company_type || '资源类' === company_type) {
                    window.location.href = '/download/smodel.zip';
                }
            },*/
            /*
            // 查询企业基本信息表
            getCompanyInfoList() {
                let _this = this;
                util.publicget('/api/getCompanyList', {
                    equalsCompany_code: document.cookie.split(';')[3].split('=')[1]
                }, function (res) {
                    if (res.flag) {
                        _this.companyList.company_name = res.obj1[0].company_name;
                        _this.companyList.company_code = res.obj1[0].company_code;
                        _this.companyList.company_type = res.obj1[0].company_type;
                        _this.companyList.user_name = document.cookie.split(';')[1].split('=')[1];
                    } else {
                        _this.errorMsg('加载数据失败');
                    }
                });
            },*/
            /*download2(){
                let a = document.createElement('a');
                a.download = '111.xlsx';
                a.href = 'http://192.168.0.233:9200/download/';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            },*/
        },
        mounted() {
            this.user = document.cookie.split(';')[1].split('=')[1];
            //this.getCompanyInfoList();
        }
    };
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/diamond/imageUpload.vue